import { useTrans } from '@/shared/hooks/useTranslation';
import { Dropdown } from '@/view/shared/Dropdown';
import type { AccountMenuViewState } from '@/viewmodel/features/user';
import { Avatar, Spinner } from '@heroui/react';
import { Cog, LogOut } from 'lucide-react';
import type { ReactNode } from 'react';

export function HeaderAccountMenu({
  initials,
  openSettings,
  signOut,
}: Readonly<AccountMenuViewState>): ReactNode {
  const { t } = useTrans();

  return (
    <Dropdown
      trigger={
        initials === null ? (
          <div className="flex items-center justify-center w-8 h-8" data-testid="avatar-loader">
            <Spinner size="sm" />
          </div>
        ) : (
          <Avatar size="sm" className="cursor-pointer">
            <Avatar.Fallback>{initials}</Avatar.Fallback>
          </Avatar>
        )
      }
      actions={[
        {
          label: t('header.settings'),
          svg: <Cog className="text-muted" size={16} />,
          onClick: openSettings,
        },
        {
          label: t('header.logout'),
          svg: <LogOut className="text-muted" size={16} />,
          onClick: signOut,
        },
      ]}
    />
  );
}
